<div class="container">
  <p-checkbox inputId="checkbox" [binary]="true" [formControl]="control()" />
  <label class="label-right-of-box" for="checkbox">{{label()}}</label>
</div>